import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import {
  AfterViewInit,
  Component,
  OnDestroy,
  OnInit,
  ViewChild,
} from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import {
  VanTransfer,
  VanTransferLocal,
  Routes,
  VanTrasnferRoute,
} from 'src/app/core/models/vanTransfer.model';
import { VanTransferService } from 'src/app/core/services/vanTransfer.service';
import { ToastService } from 'src/app/shared/widget/notification/toast-service';
import { User } from 'src/app/core/models/persons.model';
import { AuthService } from 'src/app/core/services/auth.service';
import { GoogleMap } from '@angular/google-maps';
import { Observable, of } from 'rxjs';
import { catchError, delay, map } from 'rxjs/operators';
import { PositionsService } from 'src/app/core/services/positions.service';
import { DatePipe } from '@angular/common';
import { isNullOrUndefined } from 'util';
import { UserAudit } from 'src/app/core/models/userAudit';
import { UserLogan, UserLoganAirports } from 'src/app/core/models/userLogan';
import { environment } from 'src/environments/environment';
import { Loader } from '@googlemaps/js-api-loader';

@Component({
  selector: 'app-vans-devices',
  templateUrl: './vans-devices.component.html',
  styleUrls: ['./vans-devices.component.scss'],
  providers: [DatePipe],
})
export class VansDevicesComponent implements OnInit {
  constructor(
    private vanTransferService: VanTransferService,
    public toastService: ToastService,
    private modalService: NgbModal,
    private authService: AuthService,
    private positionService: PositionsService,
    public datePipe: DatePipe
  ) {
    this.user = this.authService.currentUserValue;
    this.userLoganAirports.airports = this.user.airportsAllowed ?? '';
    this.userLoganAirports.filterMovidaTransfer =
      this.user.filterMovidaTransfer ?? false;
    this.userAudit = new UserAudit(
      this.authService.currentUserValue,
      'van-transfer/van-devices'
    );
  }
  options: google.maps.MapOptions = {
    center: { lat: -13.7972945, lng: -59.6173487 },
    zoom: 4,
  };

  loader = new Loader({
    apiKey: environment.googleMaps.key,
    version: 'weekly',
  });
  userAudit: UserAudit;
  userLoganAirports: UserLoganAirports = new UserLoganAirports();

  lat: number = 51.673858;
  lng: number = 7.815982;
  zoom: number = 4;
  maps: any;
  user: User;
  filterPlate = '';
  filterSituation: string | null = null;
  filterLocation: number | undefined;
  idUpdateVanTransfer = -1;
  allowExclude: boolean = false;
  exludeItemConfirm = false;
  vanTransfer: VanTransfer[] = [];
  vanTransferCopy: VanTransfer[] = [];
  plates: String[] = [];
  seriais: string[] = [];
  serialAuxUpdate: String = '';
  newVanTransfer: VanTransfer = new VanTransfer(null);

  updateVanTransferItem: VanTransfer = new VanTransfer(null);

  vanTransferLocal: VanTransferLocal[] = [];

  deviceSerialUpdate: string[] | null = null;

  //vanTrasnferRoutesDevicesPlatesActives: [{local:string,plates:string[]}] = [{local:'', plates: ['']}];

  public positionEvent: Event[] = [];
  public positionEventJson: any[] = [];
  seriaisMarkers: string[] = [];
  markers: google.maps.Marker[] = [];
  isBlockedDevice: boolean = false;
  isBlockedModel: boolean = false;
  isBlockedColor: boolean = false;

  routes: Routes[] = [];
  routesCopy: Routes[] = [];
  routeSelect: any = 'Selelecione uma rota';
  vanTransferRouteAux: [{ plate: string; routeId: string }] = [
    { plate: '', routeId: '' },
  ];

  circularProgressiveWait = false;
  getLocals() {
    this.vanTransferLocal = [];
    this.vanTransferService
      .selectVanTransferLocal(this.userLoganAirports)
      .subscribe((response: any) => {
        this.vanTransferLocal = response;
      });
  }

  getDataByPlate() {
    this.isBlockedDevice = false;
    this.isBlockedColor = false;
    this.isBlockedModel = false;
    this.newVanTransfer.plate = this.newVanTransfer.plate.replace(/[^a-zA-Z0-9]/g, '');
    var plate = this.newVanTransfer.plate;
    let airports : string[] = this.userLoganAirports.airports?.split(",") || [];
    this.newVanTransfer.localId = Number(airports[0]);
    if(plate) {
      this.vanTransferService.searchPlate(plate).subscribe(
        (response:any) => {
          this.newVanTransfer.chassis = response.chassi;
          this.newVanTransfer.color = response.color;
          if(response.color != null) this.isBlockedColor = true; //Bloqueia edição da cor
          this.newVanTransfer.deviceSerial = response.serie;
          if(response.serie != null) this.isBlockedDevice = true; //Bloqueia edição do número de série
          this.newVanTransfer.model = response.model;
          if(response.model != null) this.isBlockedModel = true; //Bloqueia edição do modelo
          this.newVanTransfer.deviceModel = response.device_model;
          this.newVanTransfer.idUser = this.user.userId;
          if(response.status == "error") {
            this.toastService.show("Não encontrado registros para a placa : " + plate, {
              classname: 'bg-warning text-center text-white',
              delay: 10000,
            })
          }
        },
        (error: HttpErrorResponse) => {
          this.toastService.show('Erro ao buscar dados da placa ' + plate + "\n" + error.message, {
            classname: 'bg-danger text-center text-white',
            delay: 10000,
          });
        }
      ) 
    }  
    else {
        this.toastService.show("O campo placa não pode ser vazio ou nulo!", {
        classname: 'bg-warning text-center text-white',
        delay: 10000,
        }
      )
    } 
  }

  getRoutes() {
    this.routes = [];
    this.vanTransferService.selectRoutes(this.userLoganAirports).subscribe(
      (response: any) => {
        this.routes = response;
        this.routesCopy = response;
        try {
          let coords: any[] = this.routesCopy[0].movidaCoordIcon.split(',');
          this.lat = coords[1];
          this.lng = coords[2];
          this.zoom = 14;
        } catch (error) {}
      },
      (error: HttpErrorResponse) => {
        this.toastService.show('Erro ao carregar rotas- ' + error.message, {
          classname: 'bg-danger text-center text-white',
          delay: 10000,
        });
      }
    );
  }

  filterRoute(route: Routes[], localId: number | undefined) {
    return route.filter((item: Routes) => {
      return item.localId == localId;
    });
  }

  returnRouteIdString(item: any) {
    return String(item);
  }

  verifyDeviceWithOtherRoute(devices: string[], plate: string) {
    let result = false;
    let vanTransferAux: VanTransfer[] = [];
    vanTransferAux = this.vanTransfer.filter((item: VanTransfer) => {
      return Number(item.routes_id).toString() != 'NaN' && item.plate != plate;
    });
    vanTransferAux.forEach((itemVans: any) => {
      itemVans.deviceSerial?.forEach((itemDevice: string) => {
        devices.forEach((itemDeviceTyrChangeRoute: string) => {
          if (itemDevice == itemDeviceTyrChangeRoute) {
            result = true;
          }
        });
      });
    });
    return result;
  }
  changeVanTransferRoute(item: VanTransfer) {
    var vanTransferRoute = new VanTrasnferRoute();

    var routeInitialAux = this.vanTransferRouteAux.findIndex(
      (routeAux: any) => {
        return routeAux.plate == item.plate;
      }
    );
    var routeFrom = String(this.vanTransferRouteAux[routeInitialAux].routeId);
    var routeTo = String(item.routes_id);

    if (routeFrom != routeTo) {
      if (
        routeTo != 'null' &&
        this.verifyDeviceWithOtherRoute(
          item.deviceSerial ? item.deviceSerial : [],
          item.plate
        )
      ) {
        try {
          item.routes_id = routeFrom;
          window.alert(
            'Dispositivo já está em outra rota ativa. Passe a outra placa para "Fora de Operação" antes de alterar esta'
          );
          window.location.reload();
        } catch (error) {}
      } else {
        vanTransferRoute.vanTransferPlate = item.plate;
        vanTransferRoute.email = this.user.email;
        vanTransferRoute.isActive = routeTo == 'null' ? false : true;
        vanTransferRoute.routeId = routeTo == 'null' ? routeFrom : routeTo;
        this.circularProgressiveWait = true;
        this.vanTransferService
          .changeVanTransferRoute(vanTransferRoute)
          .subscribe(
            (response: any) => {
              this.toastService.show('Rota vinculada com sucesso', {
                classname: 'bg-success text-center text-white',
                delay: 2500,
              });
              this.vanTransferService.reloadCache();
              this.getVanTransfer();
              this.getRoutes();
            },
            (error: HttpErrorResponse) => {
              this.getVanTransfer();
              this.toastService.show(
                'Erro ao vincular rotas- ' + error.message,
                {
                  classname: 'bg-danger text-center text-white',
                  delay: 10000,
                }
              );
            }
          );
      }
    }
  }

  async initializeMap() {
    if (!this.maps) {
      await this.loader.importLibrary('geometry');
    }
    const { Map } = (await google.maps.importLibrary(
      'maps'
    )) as google.maps.MapsLibrary;

    this.maps = new Map(
      document.getElementById('map') as HTMLElement,
      this.options
    );
  }

  ngOnInit(): void {
    this.getVanTransfer();
    this.getLocals();
    this.getRoutes();
  }
  initMap() {
    this.initializeMap();
    this.markers = [];
  }

  epochToDateTime(eventJson: any) {
    eventJson.data_hora_evento = this.datePipe.transform(
      new Date(eventJson.data_hora_evento).toUTCString(),
      'dd-MM-yyyy HH:mm:ss'
    )!;
    eventJson.data_hora_recebimento = this.datePipe.transform(
      new Date(eventJson.data_hora_recebimento).toUTCString(),
      'dd-MM-yyyy HH:mm:ss'
    )!;
    eventJson.data_hora_armazenamento = this.datePipe.transform(
      new Date(eventJson.data_hora_armazenamento).toUTCString(),
      'dd-MM-yyyy HH:mm:ss'
    )!;
    if (eventJson.data_hora_temperatura) {
      // data_hora_temperatura vem do backend em segundos (epoch), diferente dos demais campos que vem em milissegundos
      eventJson.data_hora_temperatura = this.datePipe.transform(
        new Date(eventJson.data_hora_temperatura * 1000).toUTCString(),
        'dd-MM-yyyy HH:mm:ss'
      )!;
    }

    return eventJson;
  }

  searchLastPosition(): void {
    this.initMap();
    this.positionEventJson = [];
    this.markers = [];
    this.circularProgressiveWait = true;
    let serialList: string[] = [];
    this.vanTransfer.forEach((item: VanTransfer) => {
      if (item.deviceSerial) {
        item.deviceSerial?.forEach((deviceItem: string) => {
          serialList.push(deviceItem);
        });
      }
    });
    serialList = serialList.filter((v, i, a) => a.indexOf(v) === i);
    var serialListWithoutLastPosition = serialList;
    this.positionService
      .getLastPositionJson(serialList, this.userAudit)
      .subscribe(
        (response: any) => {
          if (response != null) {
            var positionEvent = response;
            positionEvent
              .slice()
              .reverse()
              .forEach((event: any) => {
                let eventJsonParseDate: any = this.epochToDateTime(
                  JSON.parse(event)
                );
                try {
                  serialListWithoutLastPosition =
                    serialListWithoutLastPosition.filter((obj: any) => {
                      return obj !== eventJsonParseDate.rastreador.numero_serie;
                    });
                } catch {}

                try {
                  eventJsonParseDate.revgeo.bairro = decodeURI(
                    eventJsonParseDate.revgeo.bairro
                  );
                  eventJsonParseDate.revgeo.logradouro = decodeURI(
                    eventJsonParseDate.revgeo.logradouro
                  );
                  eventJsonParseDate.revgeo.municipio = decodeURI(
                    eventJsonParseDate.revgeo.municipio
                  );
                } catch (error) {}
                this.setMakerPosition(eventJsonParseDate);
                this.positionEventJson.push(eventJsonParseDate);
              });
            this.circularProgressiveWait = false;
            try {
              this.maps.setCenter({
                lat: this.positionEventJson[0].gps.latitude,
                lng: this.positionEventJson[0].gps.longitude,
              });
              this.maps.setZoom(this.zoom);
            } catch (error) {}

            this.circularProgressiveWait = false;
            if (serialListWithoutLastPosition.length > 0) {
              this.toastService.show(
                'Sem resultado para os seriais: ' +
                  serialListWithoutLastPosition.join(';'),
                {
                  classname: 'bg-warning text-center text-white',
                  delay: 10000,
                }
              );
            } else {
              this.toastService.show('Sucesso', {
                classname: 'bg-success text-center text-white',
                delay: 2500,
              });
            }
          } else {
            this.circularProgressiveWait = false;
          }
        },
        (error: HttpErrorResponse) => {
          this.toastService.show('Erro ao pesquisar - ' + error.message, {
            classname: 'bg-danger text-center text-white',
            delay: 5000,
          });
          this.circularProgressiveWait = false;
        }
      );
  }
  setMakerPosition(positionEvent: any) {
    var color = '#1e90ff';
    if (positionEvent.flags.posicao_online) {
      if (positionEvent.gps.fixado) {
        color = '#1e90ff';
      } else {
        color = 'black';
      }
    } else if (positionEvent.gps.fixado) {
      color = 'red';
    } else {
      color = 'purple';
    }

    var icon = {
      path:
        positionEvent.gps.proa > -1
          ? google.maps.SymbolPath.FORWARD_CLOSED_ARROW
          : google.maps.SymbolPath.CIRCLE,
      fillColor: color,
      fillOpacity: 0.9,
      strokeWeight: 0.8,
      rotation: positionEvent.gps.proa,
      scale: positionEvent.gps.proa > -1 ? 3 : 5,
    };

    let vanTranferAux = this.vanTransfer.filter((item: VanTransfer) => {
      if (item.deviceSerial) {
        return (
          item.deviceSerial.findIndex((deviceItem: string) => {
            return deviceItem == positionEvent.rastreador.numero_serie;
          }) != -1
        );
      }
      return false;
    });
    let plate = '';
    if (vanTranferAux.length > 1) {
      vanTranferAux.forEach((item: VanTransfer) => {
        if (plate != '') {
          plate = plate + ' | ';
        }
        plate = plate + item.plate;
      });
    } else if (vanTranferAux.length > 0) {
      plate = vanTranferAux[0].plate;
    }
    const infowindow = new google.maps.InfoWindow({
      content: ` <div style="line-height: 0.5;">
      <br></br>
      <p><span"><strong>${positionEvent.rastreador.numero_serie}</strong></span></p>
      <p><span style="color: #ff0000;"><strong>${positionEvent.data_hora_evento}</strong></span></p>
      <p><strong>Placa:</strong> ${plate}</p>
      <p><strong>GpsFix:</strong> ${positionEvent.gps.fixado}</p>
      <p><strong>PosicaoOnline:</strong>${positionEvent.flags.posicao_online}</p>
      <p><strong>Velocidade:</strong> ${positionEvent.gps.velocidade}</p>
      </div>
      `,
    });

    const marker = new google.maps.Marker({
      position: {
        lat: positionEvent.gps.latitude,
        lng: positionEvent.gps.longitude,
      },
      icon: icon,
      title: `<p><span style="color: #ff0000;"><strong>${positionEvent.dataHoraEvento}</strong></span></p>`,
      label: `${this.markers.length + 1}`,
    });
    marker.addListener('click', () => {
      infowindow.open({
        anchor: marker,
        shouldFocus: false,
      });
    });
    marker.setMap(this.maps);
    this.seriaisMarkers.push(positionEvent.rastreador.numero_serie);
    this.markers.push(marker);
  }

  openInfoWindowMap(id: number): void {
    google.maps.event.trigger(this.markers[id], 'click');
  }

  setCenterPositionOnMapAndOpenInfoBox(index: number): void {
    this.maps.setCenter({
      lat: this.positionEventJson[index].gps.latitude,
      lng: this.positionEventJson[index].gps.longitude,
    });
    this.maps.setZoom(this.zoom);
    this.openInfoWindowMap(index);
  }

  filterClear() {
    this.vanTransfer = this.vanTransferCopy;
    this.routes = this.routesCopy;
    this.filterPlate = '';
    this.filterSituation = '';
    this.filterLocation = undefined;
    this.filterMarker();
  }

  filter() {
    this.vanTransfer = this.vanTransferCopy;
    this.routes = this.routesCopy;
    if (this.filterPlate != '') {
      this.vanTransfer = this.vanTransfer.filter((item) => {
        return item.plate.startsWith(this.filterPlate);
      });
      this.routes = this.routes.filter((item) => {
        return item.plates?.startsWith(this.filterPlate);
      });
    }
    if (this.filterSituation != null) {
      this.vanTransfer = this.vanTransfer.filter((item) => {
        var returnStatus =
          this.filterSituation ==
          item.deviceSerialLastPositionHTML?.split(';')[0]
            ? true
            : false;
        return returnStatus;
      });
    }
    if (this.filterLocation != undefined) {
      this.vanTransfer = this.vanTransfer.filter((item) => {
        return (
          (item.localId ? item.localId : -1) == Number(this.filterLocation)
        );
      });
      this.routes = this.routes.filter((item) => {
        return (
          (item.localId ? item.localId : -1) == Number(this.filterLocation)
        );
      });
      try {
        let coords: any[] = this.routes[0].movidaCoordIcon.split(',');
        this.lat = coords[1];
        this.lng = coords[2];
        this.zoom = 14;
      } catch (error) {}
    }
    this.filterMarker();
  }

  filterMarker() {
    this.markers.forEach((item: google.maps.Marker) => {
      item.setMap(null);
    });
    this.vanTransfer.forEach((item: VanTransfer) => {
      if (item.deviceSerial) {
        item.deviceSerial.forEach((deviceItem: string) => {
          let index = this.seriaisMarkers.findIndex(
            (serialMarkerItem: string) => {
              return deviceItem == serialMarkerItem;
            }
          );
          if (index != -1) {
            this.markers[index].setMap(this.maps);
          }
        });
      }
    });
  }

  returnLocal(id: any) {
    var index = this.vanTransferLocal.findIndex((item) => {
      return item.id == id;
    });
    return index < 0 ? '' : this.vanTransferLocal[index].name;
  }

  returnColorStatusPlate(plate: string) {
    let index: number = -1;
    index = this.vanTransfer.findIndex((itemVanTransfer: VanTransfer) => {
      return itemVanTransfer.plate == plate;
    });
    if (index > -1) {
      return this.returnColorStatusSerial(
        this.vanTransfer[index].deviceSerialLastPositionHTML ?? ''
      );
    }
    return '';
  }

  returnColorStatusPlateTooltip(plate: string) {
    let index: number = -1;
    index = this.vanTransfer.findIndex((itemVanTransfer: VanTransfer) => {
      return itemVanTransfer.plate == plate;
    });
    if (index > -1) {
      return this.returnColorTooltipSerial(
        this.vanTransfer[index].deviceSerialLastPositionHTML ?? ''
      );
    }
    return '';
  }

  returnColorStatusSerial(item: string) {
    return item.split(';')[0];
  }
  returnColorTooltipSerial(item: string) {
    return item.split(';')[1];
  }
  getStatusDateTimeDeviceSerial(
    datetimeLastPosition: string,
    device: string[] | null
  ) {
    let color = '';
    let dateDevice: any[] = [];
    device = device;
    let index = 0;
    let dateTimeLastPositionAux = datetimeLastPosition.split(';');
    dateTimeLastPositionAux = datetimeLastPosition.endsWith(';')
      ? dateTimeLastPositionAux.slice(0, dateTimeLastPositionAux.length - 1)
      : dateTimeLastPositionAux;
    dateTimeLastPositionAux.forEach((item: any) => {
      index = index + 1;
      try {
        if (item != '') {
          let diffMs = new Date().getTime() - new Date(Number(item)).getTime();
          let diffMins = Math.round(diffMs * 0.00001667);
          dateDevice.push(
            `${
              device != null
                ? typeof device === 'string'
                  ? device
                  : device[index]
                : ''
            }|${this.datePipe.transform(
              new Date(Number(item)).toUTCString(),
              'dd-MM-yyyy HH:mm:ss'
            )!}`
          );
          if (diffMins > 60 && color != 'green' && color != 'yellow') {
            color = 'red';
          } else if (diffMins > 30 && color != 'green') {
            color = 'yellow';
          } else {
            color = 'green';
          }
        } else {
          dateDevice.push(
            `${
              device != null
                ? typeof device === 'string'
                  ? device
                  : device[index]
                : ''
            }|Sem posição`
          );
          color = 'red';
        }
      } catch (error) {
        dateDevice.push(
          `${
            device != null
              ? typeof device === 'string'
                ? device
                : device[index]
              : ''
          }|Sem posição`
        );
        color = 'red';
      }
    });
    return (
      color + ';' + dateDevice.join('\n')
    ); /*`<svg width="100" height="100" >
    <circle
      cx="50"
      cy="50"
      r="12"
      stroke="green"
      stroke-width="1"
      fill="yellow"
    />
  </svg>`;*/
  }

  getVanTransfer() {
    this.circularProgressiveWait = true;
    this.vanTransfer = [];
    this.vanTransferService.getVanTransfer(this.userLoganAirports).subscribe(
      (response: any) => {
        this.vanTransfer = response;
        this.vanTransferCopy = response;
        this.vanTransferRouteAux = [{ plate: '', routeId: '' }];
        this.vanTransfer.forEach((item: VanTransfer) => {
          item.deviceSerialLastPositionHTML =
            this.getStatusDateTimeDeviceSerial(
              item.deviceSerialLastPosition
                ? item.deviceSerialLastPosition
                : '',
              item.deviceSerial
            );
          this.vanTransferRouteAux.push({
            plate: item.plate,
            routeId: String(item.routes_id),
          });
          this.plates.push(item.plate.toLocaleLowerCase().replace('-', ''));
          if (item.deviceSerial?.length) {
            var aux = item.deviceSerial;
            item.deviceSerial = aux.toString().split(',');
          }
        });

        this.circularProgressiveWait = false;
      },
      (error: HttpErrorResponse) => {
        this.toastService.show('Erro ao carregar - ' + error.message, {
          classname: 'bg-danger text-center text-white',
          delay: 10000,
        });
        this.circularProgressiveWait = false;
      }
    );
  }

  insertNewVanTransfer() {
    this.circularProgressiveWait = true;

    this.newVanTransfer.email = this.user.email;
    this.vanTransferService.insertVanTransfer(this.newVanTransfer).subscribe(
      (response: any) => {
        this.toastService.show('Van ' + this.newVanTransfer.plate + ' cadastrada com sucesso!', {
          classname: 'bg-success text-center text-white',
          delay: 10000,
        });
        this.vanTransferService.reloadCache();
        this.getVanTransfer();
        this.newVanTransfer = new VanTransfer(null);
        if(response.error || response.exception){
          this.toastService.show(response.error || response.exception, {
          classname: 'bg-danger text-center text-white',
          delay: 10000,
        });
        this.circularProgressiveWait = false;
        this.isBlockedColor = false;
        this.isBlockedDevice = false;
        this.isBlockedModel = false;
        }
      },
      (error: HttpErrorResponse) => {
        this.getVanTransfer();
        this.toastService.show('Erro ao inserir - ' + error.message, {
          classname: 'bg-danger text-center text-white',
          delay: 10000,
        });
        this.circularProgressiveWait = false;
      }
    );
  }

  async updateItem(item: any, plate: string) {
    this.circularProgressiveWait = true;
    item.email = this.user.email;
    item.devicesToInactive = this.deviceSerialUpdate
      ?.filter((itemDevices) => {
        return (
          item.deviceSerial.findIndex((serial: string) => {
            return itemDevices == serial;
          }) == -1
        );
      })
      .join(';');
    item.deviceSerial = item.deviceSerial.join(';');
    this.vanTransferService.updateVanTransfer(item, plate).subscribe(
      (response) => {
        this.toastService.show('Atualizado com sucesso', {
          classname: 'bg-success text-center text-white',
          delay: 10000,
        });
        this.vanTransferService.reloadCache();
        this.getVanTransfer();
      },
      (error: HttpErrorResponse) => {
        this.getVanTransfer();

        this.toastService.show('Erro ao atualizar - ' + error, {
          classname: 'bg-danger text-center text-white',
          delay: 10000,
        });
      }
    );
  }

  addDeviceSerialUpdate(serial: string) {
    if (this.deviceSerialUpdate == null) {
      this.deviceSerialUpdate = [serial];
    } else {
      this.deviceSerialUpdate?.push(serial);
    }
  }
  openModalSmall(centerDataModal: any) {
    this.modalService.open(centerDataModal, {
      size: 'sm',
      centered: true,
      windowClass: 'modal-holder',
    });
  }

  updateModal(item: any, modal: any) {
    this.updateVanTransferItem = new VanTransfer(item);
    this.openModal(modal);
  }

  inactiveVanTransfer(plate: string) {
    if (confirm('Tem certeza que deseja inativar a placa ' + plate + '?')) {
      this.circularProgressiveWait = true;
      this.vanTransferService.inactiveVanTransfer(plate, this.userAudit.usuarioId).subscribe(
        (response) => {
          this.toastService.show('Placa inativada com sucesso!', {
            classname: 'bg-success text-center text-white',
            delay: 2500,
          });
          this.vanTransferService.reloadCache();
          this.ngOnInit();
          this.circularProgressiveWait = false;
        },
        (error: HttpErrorResponse) => {
          this.circularProgressiveWait = false;
          this.toastService.show('Erro ao inativar placa - ' + error.message, {
            classname: 'bg-danger text-center text-white',
            delay: 10000,
          });
        }
      );
    }
    else {
      //close
    }
  }

  daleteVanTransfer(plate: string) {
    if (confirm('Tem certeza que deseja deletar a placa ' + plate + '?')) {
      this.circularProgressiveWait = true;
      this.vanTransferService.deleteVanTransfer(plate).subscribe(
        (response) => {
          this.toastService.show('Placa deletada com sucesso!', {
            classname: 'bg-success text-center text-white',
            delay: 2500,
          });
          this.vanTransferService.reloadCache();
          this.ngOnInit();
          this.circularProgressiveWait = false;
        },
        (error: HttpErrorResponse) => {
          this.circularProgressiveWait = false;
          this.toastService.show('Erro ao inativar placa - ' + error.message, {
            classname: 'bg-danger text-center text-white',
            delay: 10000,
          });
        }
      );
    }
    else {
      //close
    }
  }

  openModalUpdate(item: any, centerDataModal: any) {
    var vanTransferUpdateAux = new VanTransfer(item);
    this.deviceSerialUpdate = item.deviceSerial;

    this.serialAuxUpdate = item.plate;
    this.updateVanTransferItem = vanTransferUpdateAux;

    this.modalService.open(centerDataModal, {
      centered: true,
      windowClass: 'modal-holder',
    });
  }
  openModal(centerDataModal: any) {
    this.modalService.open(centerDataModal, {
      centered: true,
      windowClass: 'modal-holder',
    });
  }
}

interface marker {
  lat: number;
  lng: number;
  label?: string;
  UrlIcon: string;
  proa: number;
}
